import React from 'react';
import Sidebar from './Sidebar';
import NotificationBell from './NotificationBell';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-slate-50/50">
      <Sidebar />
      {/* Top bar with notifications (desktop) */}
      <div className="hidden lg:flex fixed top-0 left-72 right-0 h-14 items-center justify-end px-6 bg-white/80 backdrop-blur-md border-b border-slate-200/60 z-40">
        <NotificationBell />
      </div>
      <main className="lg:pl-72 pt-16 lg:pt-14 min-h-screen">
        <div className="p-6 lg:p-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
